DeviceManager.Internal.BarcodeScanner = {};
//# sourceMappingURL=barcode-scanner.js.map
